import React, { createContext, useEffect, useRef, useState } from "react";
import GlobalHeader from "../../components/header";
import validator from 'validator';

import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import useApi from "../../hooks/useApi";
import useSnack from "../../hooks/useSnack";
import SnackAlert from "../../components/SnackAlert";
import dataTest from "./data.json";
import GalleryProfile from "../../components/GalleryProfile";
import AbcIcon from "@mui/icons-material/Abc";
import { Email, Phone } from "@mui/icons-material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ProjectsProfile from "../../components/ProjectsProfile";
import ModalDeleteProject from "../../components/Modals/ModalDeleteProject";
import ModalCreateProject from "../../components/Modals/ModalCreateProject";
import ImagePerson from "../../images/perfil.svg";

export const ProfileContext = createContext();

function Profile() {
  // MAIN REQUEST
  const GetUser = async () => {
    setOpenBackDrop(true);
    loadApi("profile/profile", true, "get")
      .then((response) => {
        setGalleryImages(response.data.profile.gallery);
        setPreviewName(response.data.profile.name);
        setDataProfile({
          name: response.data.profile.User.name,
          about_me: response.data.profile.about_me,
          contact: response.data.profile.contact,
          photo_profile: response.data.profile.photo_profile,
          address: response.data.profile.address,
          User: response.data.profile.User,
          gallery: response.data.profile.gallery,
          gallery_edit: [],
          industry: response.data.profile.industry,
          projects: response.data.profile_projects,
        });
        setShowData(true);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => {
        setOpenBackDrop(false);
      });
  };

  // DATA
  const [previewName, setPreviewName] = useState("");
  const [dataProfile, setDataProfile] = useState({
    photo_profile: "",
    name: "",
    contact: [{ email: "", phone: "" }],
    User: "",
    about_me: "",
    address: "",
    industry: "",
    gallery: "",
    gallery_edit: [],
  });
  const [dataNewProject, setDataNewProject] = useState({
    name: "",
    phone: "",
    email: "",
    web: "",
  });
  const [previewImage, setPreviewImage] = useState(false);
  const [currentDeleteId, setCurrentDeleteId] = useState();
  const [galleryImages, setGalleryImages] = useState();

  // UTILS
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();

  // STATES FUNCTION
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingButtonDelete, setLoadingButtonDelete] = useState(false);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [showData, setShowData] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalNew, setModalNew] = useState(false);
  const fileInputRef = useRef(null);
  const addImageGallery = useRef(null);

  const UpdateUser = async () => {
    setLoadingButton(true);

    loadApi("profile/update_profile", true, "put", { ...dataProfile }, true)
      .then((response) => {
        showSnack("Datos actualizados correctamente", "success");
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => {
        setLoadingButton(false);
      });
  };

  const DeleteProject = async (id) => {
    setLoadingButtonDelete(true);
    loadApi(`profile/delete_profile_project/${id}`, true, "delete")
      .then((response) => {
        const newArray = dataProfile.projects.filter(
          (x) => x.id !== currentDeleteId
        );
        setDataProfile({ ...dataProfile, projects: newArray });
        showSnack("Proyecto eliminado con éxito", "success");
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => {
        setLoadingButtonDelete(false);
        setModalOpen(false);
      });
  };

  const CreateProject = async () => {
    setLoadingButtonDelete(true);
    loadApi(`profile/create_profile_projects`, true, "post", {
      ...dataNewProject,
    })
      .then((response) => {
        setDataProfile({
          ...dataProfile,
          projects: [
            ...dataProfile.projects,
            { ...dataNewProject, id: response.data.newProject.id },
          ],
        });
        showSnack(response.data.message, "success");
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => {
        setLoadingButtonDelete(false);
        setModalNew(false);
      });
  };

  // SET PROFILE PICTURE
  const handlerSetPicture = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => setPreviewImage(e.target.result);
      reader.readAsDataURL(selectedFile);
      setDataProfile({
        ...dataProfile,
        photo_profile_edit: selectedFile,
      });
    } else {
      setPreviewImage(null);
    }
  };

  // ADD IMAGE TO GALLERY
  const handlerAddImage = (event) => {
    const selectedFile = event.target.files[0];

    // EVITAR DUPLICADOS
    const isDuplicate = galleryImages.filter(
      (x) => x.name === selectedFile.name
    );

    if (isDuplicate.length !== 0) {
      addImageGallery.current.value = "";
      showSnack("Error, el archivo ya existe");
      return;
    }
    setDataProfile({
      ...dataProfile,
      gallery_edit: [...dataProfile.gallery_edit, selectedFile],
    });

    // CODIGO PARA AÑADIR IMAGEN DE PREVISUALIZACION
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setGalleryImages([
          ...galleryImages,
          { url: e.target.result, name: selectedFile.name },
        ]);
      };
      reader.readAsDataURL(selectedFile);
    }
    addImageGallery.current.value = "";
  };

  const handlerDeleteProject = () => {
    DeleteProject(currentDeleteId);
  };

  const handlerNewProject = (e) => {
    e.preventDefault();
    CreateProject();
  };

  useEffect(() => {
    GetUser();
  }, []);

  function validateEmail(email) {
    return validator.isEmail(email, {
      allow_utf8_local_part: true,
      require_tld: true,
      allow_ip_domain: true
    });
  }

  return (
    <ProfileContext.Provider
      value={{
        modalNew,
        setDataNewProject,
        setModalNew,
        dataNewProject,
        loadingButtonDelete,
        handlerNewProject,
      }}
    >
      <GlobalHeader />
      <Stack
        component="main"
        sx={{
          backgroundColor: "white",
          marginInline: "auto",
          minHeight: "100vh",
          width: { xs: "97vw", sm: "85vw", md: "80vw", lg: "72vw" },
          py: 2,
          px: {
            xs: 0,
            md: 2,
          },
        }}
      >
        {showData && (
          <Stack
            component="form"
            sx={{ px: { xs: 2, lg: 1 } }}
            onSubmit={(event) => {
              event.preventDefault();

              // Obtener el valor del campo de texto
              const email = dataProfile.contact[0]?.email || "";

              // Validar el correo
              if (validateEmail(email)) {
                UpdateUser(); // Llamar a la función de actualización
              } else {
                showSnack("Error, el correo electrónico no es válido");
              }
            }}
          >
            <Typography
              component="h1"
              variant="h4"
              sx={{
                mb: 4,
              }}
            >
              Perfil
            </Typography>
            <Stack
              component="section"
              aria-label="Main-information-user"
              sx={{
                mb: 5,
                justifyContent: {
                  xs: "center",
                  sm: "flex-start",
                },
              }}
              flexDirection="row"
            >
              <Stack
                component="article"
                sx={{
                  width: { xs: 120, sm: 150, md: 200, lg: 200 },
                  m: 0,
                  mr: 4,
                  flexDirection: "column",
                  alignItems: "center",
                }}
                onClick={() => fileInputRef.current.click()}
              >
                <img
                  src={
                    previewImage ||
                    dataProfile.photo_profile[0].url ||
                    ImagePerson
                  }
                  width="100%"
                  style={{
                    aspectRatio: "1/1",
                    maxWidth: "100%",
                    borderRadius: "15%",
                    objectFit: "cover",
                  }}
                />

                <input
                  type="file"
                  accept=".jpg, .png, .jpeg"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handlerSetPicture}
                />
              </Stack>
              <Stack component="article" sx={{ pt: 2 }}>
                <Typography component="h2" variant="h5" mb={1}>
                  {previewName}
                </Typography>
                <Typography
                  sx={{ color: "gray", mb: 0.5, fontWeight: 700, fontSize: 22 }}
                >
                  {dataProfile.User.name}
                </Typography>
                <Typography
                  sx={{
                    color: "gray",
                    userSelect: "none",
                  }}
                >
                  {dataProfile.User.username}
                </Typography>
              </Stack>
            </Stack>
            <Stack>
              <Grid
                container
                component="section"
                aria-label="inputs-edit"
                mb={2}
                columns={2}
                spacing={{ xs: 0, sm: 2, lg: 2 }}
                sx={{
                  mr: 0,
                  marginInline: "auto",
                  width: "100%",
                }}
              >
                <Grid item component="article" xs={2} md={1} lg={1}>
                  <Box>
                    <Typography component="h3" variant="h6" sx={{ mb: 2 }}>
                      Información básica nombre
                    </Typography>
                    <TextField
                      value={dataProfile.name}
                      label="Nombre"
                      fullWidth
                      sx={{ mb: 2 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AbcIcon />
                          </InputAdornment>
                        ),
                      }}
                      inputProps={{
                        minLength: 2,
                        maxLength: 25,
                      }}
                      onChange={(target) => {
                        setDataProfile({
                          ...dataProfile,
                          name: target.target.value,
                        });
                      }}
                    />

                    <TextField
                      value={dataProfile.about_me}
                      label="Sobre mí"
                      fullWidth
                      sx={{ mb: 2 }}
                      // inputProps={{
                      //   minLength: 5,
                      //   maxLength: 25,
                      // }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AbcIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(target) => {
                        setDataProfile({
                          ...dataProfile,
                          about_me: target.target.value,
                        });
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item component="article" xs={2} md={1} lg={1}>
                  <Box>
                    <Typography component="h3" variant="h6" sx={{ mb: 2 }}>
                      Información de contacto
                    </Typography>
                    <TextField
                      value={dataProfile.contact[0]?.email || ""}
                      label="Correo electrónico de contacto"
                      type="email"
                      fullWidth
                      sx={{ mb: 2 }}
                      error={
                        dataProfile.contact[0]?.email &&
                        !validateEmail(dataProfile.contact[0]?.email)
                      }
                      helperText={
                        dataProfile.contact[0]?.email &&
                        !validateEmail(dataProfile.contact[0]?.email) &&
                        "Por favor ingrese un correo electrónico válido (ejemplo@gmail.com)"
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Email
                              color={
                                dataProfile.contact[0]?.email &&
                                  !validateEmail(dataProfile.contact[0]?.email)
                                  ? "error"
                                  : "primary"
                              }
                            />
                          </InputAdornment>
                        ),
                      }}
                      onChange={({ target }) => {
                        const updatedContact = [...dataProfile.contact];
                        updatedContact[0] = {
                          ...updatedContact[0],
                          email: target.value,
                        };
                        setDataProfile({
                          ...dataProfile,
                          contact: updatedContact,
                        });
                      }}
                    />
                    <TextField
                      value={dataProfile.contact[0]?.phone || ""}
                      label="Teléfono"
                      type="text"
                      fullWidth
                      sx={{ mb: 2 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Phone />
                          </InputAdornment>
                        ),
                      }}
                      inputProps={{
                        minLength: 8,
                        maxLength: 15,
                      }}
                      onChange={({ target }) => {
                        const onlyNums = target.value.replace(/[^0-9]/g, "");
                        const updatedContact = [...dataProfile.contact];
                        updatedContact[0] = {
                          ...updatedContact[0], // Mantenemos los valores existentes
                          phone: onlyNums, // Solo actualizamos el phone
                        };
                        setDataProfile({
                          ...dataProfile,
                          contact: updatedContact,
                        });
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item component="article" xs={2} md={1} lg={1}>
                  <Box>
                    <Typography component="h3" variant="h6" sx={{ mb: 2 }}>
                      Dirección
                    </Typography>
                    <TextField
                      value={dataProfile.address?.[0]?.city || ""} // Usamos optional chaining para evitar errores
                      label="Ciudad"
                      fullWidth
                      sx={{ mb: 2 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AbcIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={({ target }) => {
                        const updatedAddress =
                          Array.isArray(dataProfile.address) &&
                            dataProfile.address.length > 0
                            ? [...dataProfile.address]
                            : [{ city: "", address: "" }]; // Aseguramos que siempre sea un array con un objeto

                        updatedAddress[0] = {
                          ...updatedAddress[0], // Mantenemos los otros valores
                          city: target.value, // Actualizamos solo la ciudad
                        };

                        setDataProfile({
                          ...dataProfile,
                          address: updatedAddress,
                        });
                      }}
                    />

                    <TextField
                      value={dataProfile.address?.[0]?.address || ""}
                      label="Dirección"
                      fullWidth
                      sx={{ mb: 2 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AbcIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={({ target }) => {
                        const updatedAddress =
                          Array.isArray(dataProfile.address) &&
                            dataProfile.address.length > 0
                            ? [...dataProfile.address]
                            : [{ city: "", address: "" }]; // Aseguramos que siempre sea un array con un objeto

                        updatedAddress[0] = {
                          ...updatedAddress[0], // Mantenemos los otros valores
                          address: target.value, // Actualizamos solo la dirección
                        };

                        setDataProfile({
                          ...dataProfile,
                          address: updatedAddress,
                        });
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item component="article" xs={2} md={1} lg={1}>
                  <Box>
                    <Typography component="h3" variant="h6" sx={{ mb: 2 }}>
                      Industria
                    </Typography>
                    <TextField
                      value={dataProfile.industry?.[0]?.name || ""} // Usamos optional chaining para evitar errores
                      label="Nombre"
                      fullWidth
                      sx={{ mb: 2 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AbcIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={({ target }) => {
                        const updatedIndustry =
                          Array.isArray(dataProfile.industry) &&
                            dataProfile.industry.length > 0
                            ? [...dataProfile.industry]
                            : [{ name: "", description: "" }]; // Aseguramos que siempre sea un array con un objeto

                        updatedIndustry[0] = {
                          ...updatedIndustry[0], // Mantenemos los otros valores
                          name: target.value, // Actualizamos solo el nombre
                        };

                        setDataProfile({
                          ...dataProfile,
                          industry: updatedIndustry,
                        });
                      }}
                    />

                    <TextField
                      value={dataProfile.industry?.[0]?.description || ""} // Usamos optional chaining para evitar errores
                      label="Descripción"
                      fullWidth
                      sx={{ mb: 2 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AbcIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={({ target }) => {
                        const updatedIndustry =
                          Array.isArray(dataProfile.industry) &&
                            dataProfile.industry.length > 0
                            ? [...dataProfile.industry]
                            : [{ name: "", description: "" }]; // Aseguramos que siempre sea un array con un objeto

                        updatedIndustry[0] = {
                          ...updatedIndustry[0], // Mantenemos los otros valores
                          description: target.value, // Actualizamos solo la descripción
                        };

                        setDataProfile({
                          ...dataProfile,
                          industry: updatedIndustry,
                        });
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Stack>
            <Stack
              aria-label="gallery"
              component="section"
              sx={{
                marginInline: "auto",
                mb: 4,
                width: {
                  xs: "100%",
                  sm: "95%",
                  lg: "100%",
                },
              }}
            >
              <Box
                flexDirection="row"
                display="flex"
                alignItems="center"
                gap={0.5}
                mb={3}
              >
                <Typography component="h3" variant="h6" sx={{ mr: 1 }}>
                  Galería
                </Typography>
                <Box>
                  <IconButton
                    onClick={() => addImageGallery.current.click()}
                    variant="contained"
                  >
                    <AddCircleIcon sx={{ color: "primary.main" }} />
                  </IconButton>
                  <input
                    type="file"
                    accept=".jpg, .png, .jpeg"
                    multiple={false}
                    style={{ display: "none" }}
                    ref={addImageGallery}
                    onChange={handlerAddImage}
                  />
                </Box>
              </Box>
              <GalleryProfile
                mainData={dataProfile}
                setDataProfile={setDataProfile}
                setGalleryImages={setGalleryImages}
                data={galleryImages}
              />
            </Stack>

            <Stack aria-label="Projects" sx={{ mb: 5 }}>
              <Box
                flexDirection="row"
                display="flex"
                alignItems="center"
                gap={0.5}
                mb={3}
              >
                <Typography component="h3" variant="h6">
                  Mis proyectos
                </Typography>
                <Box>
                  <IconButton
                    onClick={() => setModalNew(true)}
                    variant="contained"
                  >
                    <AddCircleIcon sx={{ color: "primary.main" }} />
                  </IconButton>
                </Box>
              </Box>

              <ProjectsProfile
                data={dataProfile}
                setDataProfile={setDataProfile}
                setCurrentDeleteId={setCurrentDeleteId}
                setModalOpen={setModalOpen}
              />
            </Stack>

            <LoadingButton
              sx={{
                color: "white",
                py: { xs: 0.7, sm: 1, lg: 1 },
                width: "100%",
                marginInline: "auto",
              }}
              loading={loadingButton}
              type="submit"
            >
              GUARDAR
            </LoadingButton>
          </Stack>
        )}
      </Stack>
      <ModalDeleteProject
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        loadingButtonDelete={loadingButtonDelete}
        handlerDeleteProject={handlerDeleteProject}
      />
      <ModalCreateProject />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </ProfileContext.Provider>
  );
}

export default Profile;
